import { createSlice } from '@reduxjs/toolkit';
import apiClient from '@miroculus/api-client';
import { calculateTable, getDataSource, getFilteredVariables, addCurrentRun, addRunData, addRunDatas, } from './utils';
export const DEVICE_HV_STATUS = {
    HIGH: 'high',
    LOW: 'low',
    OFF: 'off',
};
const initialState = {
    temp: {
        dataTable: [[]],
        sources: [],
        runs: [],
        variables: {},
        tracking: true,
        trackInterval: 1000,
        maxDatapoints: 100,
    },
    optics: {
        dataTable: [[]],
        sources: [
            {
                name: 'detector1',
                color: 112,
                active: true,
                lastValue: 0,
                tracking: true,
            },
            {
                name: 'detector2',
                color: 184,
                active: true,
                lastValue: 0,
                tracking: true,
            },
        ],
        runs: [],
        variables: {},
        tracking: false,
        trackInterval: 1000,
        maxDatapoints: 100,
    },
};
const dataSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        setTempSources: (state, action) => {
            state.temp.sources = action.payload;
        },
        initRuns: (state) => {
            const variables = {
                opticsVariables: {},
                tempVariables: {},
            };
            let runs = [];
            // Need to work with a mutable copy for the utility functions
            const stateCopy = JSON.parse(JSON.stringify(state));
            const response = addCurrentRun(stateCopy, variables, runs);
            runs = response.runs;
            const tempTracking = state.temp.tracking;
            state.temp = getDataSource(stateCopy, 'temp', runs, variables);
            state.optics = getDataSource(stateCopy, 'optics', runs, variables);
            // Preserve tracking checkbox between runs
            state.temp.tracking = tempTracking;
        },
        toggleVariable: (state, action) => {
            const { source, variable } = action.payload;
            const dataType = state[source];
            dataType.sources = dataType.sources.map((s) => {
                if (s.name === variable)
                    s.active = !s.active;
                return s;
            });
            const filteredVariables = getFilteredVariables(dataType);
            state[source].dataTable = calculateTable(filteredVariables);
        },
        addValue: (state, action) => {
            const { source, experiment, cocoscriptStatus } = action.payload;
            const dataType = state[source];
            // Need mutable state for utility function
            const stateCopy = JSON.parse(JSON.stringify(state));
            const newState = addRunData(dataType, stateCopy, action.payload);
            state.temp = newState.temp;
            state.optics = newState.optics;
            // Side effect: save data to backend (kept for backward compatibility)
            const exp = experiment;
            if (!exp || !exp.currentExperiment?.id)
                return;
            if (!cocoscriptStatus || cocoscriptStatus !== 1)
                return;
            const currentIndex = state[source].dataTable[state[source].dataTable.length - 1][0];
            if (!currentIndex.toString().endsWith('00'))
                return;
            const experimentId = exp.currentExperiment.id;
            const runId = exp.currentRun?.id;
            if (!experimentId || !runId)
                return;
            const table = state[source].dataTable;
            const lastValue = table[table.length - 1];
            let readyToSave = true;
            for (let i = 0; i < lastValue.length; i++) {
                readyToSave = readyToSave && !!lastValue[i];
            }
            if (!readyToSave)
                return;
            // Note: Side effect in reducer - ideally should be moved to middleware
            apiClient.put(`experiments/${experimentId}/${runId}`, {
                results: state[source].dataTable.slice(1),
            });
        },
        addValues: (state, action) => {
            const { source } = action.payload;
            const dataType = state[source];
            const stateCopy = JSON.parse(JSON.stringify(state));
            const newState = addRunDatas(dataType, stateCopy, action.payload);
            state.temp = newState.temp;
            state.optics = newState.optics;
        },
        toggleTracking: (state, action) => {
            state[action.payload].tracking = !state[action.payload].tracking;
        },
        resetTempData: () => initialState,
        setHV: (state, action) => {
            state.hv = action.payload;
        },
    },
});
// Export actions
export const { setTempSources, initRuns, toggleVariable, addValue, addValues, toggleTracking, resetTempData, setHV, } = dataSlice.actions;
// Export reducer as default
export default dataSlice.reducer;
